import WebSocketMessage from '@app/model/_common/WebSocketMessage';
import React, { PropsWithChildren } from 'react';
import MessagePublishSubscribe from '@app/component/web-socket/MessagePublishSubscribe';
import { useStompClient, useSubscription } from 'react-stomp-hooks';
import WebSocketMessageListenerSubscription from '@app/component/web-socket/WebSocketMessageListenerSubscription';


export const WebSocketMessageContext = React.createContext<MessagePublishSubscribe | undefined>(undefined);

const WebSocketMessageProvider: React.FunctionComponent<PropsWithChildren<{
	subscriptions: WebSocketMessageListenerSubscription<any>[]
}>> = ({ subscriptions, children }) => {

	const client = useStompClient();

	const pubsub = new MessagePublishSubscribe();

	subscriptions.forEach(s => pubsub.subscribe(s.messageType, s.handler));

	useSubscription('/user/secured/process-finished', (message) => {
		const m: WebSocketMessage<any> = JSON.parse(message.body);
		pubsub.publish(m.type, m);
	});

	return <WebSocketMessageContext.Provider value={pubsub}>{!!client && children}</WebSocketMessageContext.Provider>;
};

export default WebSocketMessageProvider;